import {
  GET_RESERVATION_CART_SUCCESS,
  GET_RESERVATION_CART_REQUESTING,
  RESET_RESERVATION_CART_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_RESERVATION_CART_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case GET_RESERVATION_CART_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_RESERVATION_CART_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
